<template>
	<v-img
			src="/images/logo.png"
			:width="width"
			:height="height"
			contain
	/>
</template>

<script>
export default {
	name: 'LogoComponent',
	props: {
		hasShadow: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: '#000'
		},
		width: {
			type: Number,
			default: 44.5
		},
		height: {
			type: Number,
			default: 9.8
		}
	}
}
</script>
